import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.528 9.082a.528.528 0 1 0-1.056 0v3.17a.528.528 0 0 0 1.056 0v-3.17ZM6.573 14.53a.528.528 0 0 0-.625.852l2.555 1.876a.528.528 0 1 0 .625-.852L6.573 14.53Zm19.559.113a.528.528 0 0 0-.739-.113l-2.555 1.876a.528.528 0 1 0 .626.852l2.555-1.876a.528.528 0 0 0 .113-.739Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M28.418 26.472A13.939 13.939 0 0 0 30 20c0-7.732-6.268-14-14-14S2 12.268 2 20c0 2.335.572 4.536 1.582 6.472h24.836ZM3.057 20C3.057 12.852 8.852 7.057 16 7.057S28.943 12.852 28.943 20c0 1.935-.424 3.769-1.183 5.415h-8.03c.094-.323.144-.665.144-1.017 0-1.415-.807-2.65-2-3.298l3.166-7.724a.528.528 0 1 0-.978-.4l-3.177 7.748a4.06 4.06 0 0 0-.929-.108c-2.163 0-3.918 1.695-3.918 3.782 0 .352.05.694.143 1.017h-7.94A12.892 12.892 0 0 1 3.056 20ZM16 21.585c-1.653 0-2.994 1.308-2.994 2.92 0 .334.058.655.165.954h5.659c.106-.3.164-.62.164-.955 0-1.611-1.341-2.92-2.994-2.92Z",
      clipRule: "evenodd"
    }
  )
);
var SvgOverviewOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var OverviewOutlined_default = SvgOverviewOutlined;

export { OverviewOutlined_default as default };
